import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "tag-label__container" };
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import CrossIcon2 from '@/components/icons/cross2.vue';
import debounce from 'lodash/debounce';
import { addEventListener, removeEventListener } from '@/utils/browser';
export default /*@__PURE__*/ _defineComponent({
    __name: 'tag-label',
    props: {
        color: { default: '#5F6B81' },
        theme: { default: null },
        closable: { type: Boolean, default: false },
        clickable: { type: Boolean, default: false },
        triangleBorder: { type: Boolean, default: true },
        uppercase: { type: Boolean, default: true }
    },
    emits: ['remove', 'click'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const THEME_COLORS = {
            success: '#08914F',
            danger: '#C00A47',
        };
        const props = __props;
        const container = ref();
        const height = ref(0);
        const activeColor = computed(() => {
            if (props.theme && THEME_COLORS[props.theme]) {
                return THEME_COLORS[props.theme];
            }
            return props.color;
        });
        const style = computed(() => {
            var _a;
            return ({
                color: (_a = activeColor.value) !== null && _a !== void 0 ? _a : undefined,
                backgroundColor: changeOpacity(String(activeColor.value), 0.2),
            });
        });
        const triangleStyle = computed(() => ({
            borderLeft: `6px solid ${changeOpacity(String(activeColor.value), 0.2)}`,
            borderTop: `${height.value}px solid transparent`,
            borderBottom: `${height.value}px solid transparent`,
        }));
        function changeOpacity(color, opacity) {
            // coerce values so it is between 0 and 1.
            const _opacity = Math.round(Math.min(Math.max(opacity !== null && opacity !== void 0 ? opacity : 1, 0), 1) * 255);
            return color + _opacity.toString(16).toUpperCase();
        }
        const observeWindow = debounce(() => {
            var _a, _b;
            height.value = ((_b = (_a = container.value) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0) / 2;
        }, 20);
        onMounted(() => {
            var _a, _b;
            addEventListener(window, 'resize', observeWindow);
            height.value = ((_b = (_a = container.value) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0) / 2;
        });
        onBeforeUnmount(() => {
            removeEventListener(window, 'resize', observeWindow);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.$slots.action)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        style: _normalizeStyle(style.value)
                    }, [
                        _renderSlot(_ctx.$slots, "action")
                    ], 4))
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    ref_key: "container",
                    ref: container,
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (emit('click')), ["prevent"])),
                    style: _normalizeStyle(style.value),
                    class: _normalizeClass(['tag-label', { 'tag-clickable': __props.clickable, 'text-uppercase': __props.uppercase, 'tag-label--action': _ctx.$slots.action }])
                }, [
                    _renderSlot(_ctx.$slots, "default")
                ], 6),
                (__props.closable)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        onClick: _cache[1] || (_cache[1] = ($event) => (emit('remove'))),
                        class: "tag-action-button",
                        style: _normalizeStyle(style.value)
                    }, [
                        _createElementVNode("div", null, [
                            _createVNode(CrossIcon2, { style: { "width": "6px", "height": "6px" } })
                        ])
                    ], 4))
                    : _createCommentVNode("", true),
                (__props.triangleBorder)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        style: _normalizeStyle(triangleStyle.value),
                        class: "tag-label__triangle"
                    }, null, 4))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
